export function resolvePosOfflineHint(opts: {
  isOnline: boolean;
  webBlocksOfflineWrites: boolean;
}): string | null {
  if (opts.isOnline) return null;
  if (opts.webBlocksOfflineWrites) return 'Sin conexión';
  return 'Sin conexión. Vendés con lo que ya está cargado.';
}
